import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RpcIconComponent } from '../../../core-modules/utils/rpc-icon/rpc-icon.component';

@Component({
    selector: 'saved-search-option',
    templateUrl: './saved-search-option.component.html',
    styleUrls: ['./saved-search-option.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RpcIconComponent]
})
export class SavedSearchOptionComponent {
    @Input() public savedSearchName: string;
    @Input() public savedSearchIcon = 'saved-search';
    @Input() public disabled: boolean;

    @Output() public clicked = new EventEmitter<void>();

    public onSavedSearchClick(): void {
        if (!this.disabled) {
            this.clicked.emit();
        }
    }
}
